module.exports = __webpack_public_path__ + "img/E18-curacao.c6f34318.png";